import React, { useEffect, useState } from "react";
import GradeForm from "./GradeForm";
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/gradeActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const GradeEdit = props => {
    const { classes, grade, onFetchGrade, onFetchGradeInit, activeCustomerID, translations, permissions, onEditGrade } = props;
    const [data, setData] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await onFetchGrade({ ActiveCustomerID: activeCustomerID, GradeID: parseURL(window.location.href).GradeID })
            setData(false)
        }
        fetchData();
        return () => {
            onFetchGradeInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        data["GradeID"] = grade.GradeID;
        data["CustomerID"] === "system" ? data["CustomerID"] = null    :   data["CustomerID"] = activeCustomerID;
        let result = await onEditGrade({ ...data, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack()
        }
    };

    let initialValues = {
        Condition: grade.Condition || "",
        InternationalGrading: grade.InternationalGrading || "",
        CustomerID: grade?.CustomerID ? "custom"   :   "system",
    };

    let formSettings = {
        Validation: {
            Condition: Yup.string().required("Required"),
            InternationalGrading: Yup.string().required("Required"),
            CustomerID: Yup.string().required("Required")
        },
        FormTitle: translations["edit_grade"] || "Edit grade",
        ButtonSubmit: hasPermission(permissions, grade.CustomerID? "grade_save" : "system_grade_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            {!data ?
                <GradeForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    translations={translations}
                    CustomerIDPreviousState={grade?.CustomerID ? 'custom'   :   'system'}
                    fromEdit={true}
                    permissions={permissions}
                />
                : <CircularProgress
                    variant="determinate"
                    color="primary"
                    size={28}
                />}
        </Paper>
    );
};
const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        grade: state.setting.grades && state.setting.grades.loaded ? state.setting.grades.loaded : {},
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchGradeInit: grade => dispatch(actions.loadGradeInit(grade)),
        onFetchGrade: grade => dispatch(actions.loadGrade(grade)),
        onEditGrade: grade => dispatch(actions.editGrade(grade)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(GradeEdit));
